import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { NavigationGuardContext } from "./NavigationGuardContext";

export const useNavigationGuardContext = () => {
  const context = useContext(NavigationGuardContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useNavigationGuardContext",
      "NavigationGuardContext"
    );
  }

  return context;
};
